// __root.tsx: root of the tanstack router
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { QueryClient } from '@tanstack/react-query';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => {
    return (
      <div className='flex flex-col h-full min-h-screen overflow-auto'>
        <Outlet />
      </div>
    );
  },
});
